var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "contacter-entire" }, [
    _c("div", { staticClass: "city-list-wrap" }, [
      _c(
        "div",
        {
          ref: "cityFixedTab",
          staticClass: "city-list-tab",
          attrs: { id: "cityScroll" }
        },
        [
          _c(
            "div",
            { ref: "cityBox", staticClass: "city-box flexBox" },
            _vm._l(_vm.cityList, function(city, index) {
              return _c(
                "span",
                {
                  staticClass: "city-tab-bullet",
                  class: { active: _vm.cityActiveIndex == index },
                  on: {
                    click: function($event) {
                      return _vm.clickTab(index, true)
                    }
                  }
                },
                [
                  _c("span", {
                    domProps: { textContent: _vm._s(city.ShortName) }
                  })
                ]
              )
            }),
            0
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { ref: "citycontactlist", staticClass: "city-contact-list" },
      [
        _vm._l(_vm.cityContactList, function(lists) {
          return [
            _c("contact-list", {
              attrs: {
                city: lists.CityName,
                lists: lists.PeopleList,
                has2500: _vm.has2500
              }
            })
          ]
        })
      ],
      2
    ),
    _vm._v(" "),
    _c("div", {
      staticClass: "gap-filling",
      staticStyle: { background: "#f0f1f2" },
      style: { height: _vm.gapHeight + "px" }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-67c513a7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-67c513a7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/contactEntire.vue
// module id = null
// module chunks = 